import { AlertTriangle } from "lucide-react";

export const Notice112 = ({ className = "" }) => (
  <div
    role="note"
    data-testid="notice-112"
    className={`flex flex-col gap-4 rounded-2xl border border-rosso/25 bg-white p-6 shadow-[0_8px_30px_rgba(148,47,48,0.08)] sm:flex-row sm:items-center md:p-8 ${className}`}
  >
    <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-rosso text-white">
      <AlertTriangle className="h-6 w-6" strokeWidth={1.6} />
    </span>
    <div>
      <p className="text-xs font-bold uppercase tracking-[0.24em] text-rosso">Avviso importante</p>
      <p className="mt-2 text-base leading-relaxed text-navy md:text-lg">
        Nexus Italia Group gestisce servizi sanitari <strong>non urgenti e programmati</strong> e non sostituisce il
        sistema pubblico di emergenza. <strong>In caso di emergenza chiama il 112.</strong>
      </p>
    </div>
  </div>
);
